import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import sharedReducer from './shared.reducer';
import userReducer from './user.reducer';
import activitiesReducer from './activities.reducer';
import countriesReducer from './countries.reducer';
import hostReducer from './host';
import publicListingsReducer from './public-listings.reducer';
import categoriesReducer from './categories.reducer';
import guestReducer from './guest';
import currenciesReducer from './currencies.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  shared: sharedReducer,
  activities: activitiesReducer,
  countries: countriesReducer,
  host: hostReducer,
  publicListings: publicListingsReducer,
  categories: categoriesReducer,
  guest: guestReducer,
  currencies: currenciesReducer,
});

export default rootReducer;
